module.exports = __webpack_public_path__ + "img/template15_desktop.f45a4761.png";